// Dependencies of brooklyn.js
import 'lodash';
import 'micromodal';
import 'scrolltofixed';

// Theme Main JS
import '../vendor/brooklyn';

// Styles
import '../../styles/style.scss';

// Scripts
import '../vendor/slick/slick.js';
import '../vendor/ProxyLink.js';
import '../vendor/TimedPopup.js';
import '../vendor/parsley.js';
import Tabs from '../components/tabs.js';
import '../components/gsap-collapse.js';
import '../components/knitkit.js';
import '../components/input.js';
import '../sections/announcement-bar.js';
import '../sections/low-energy-bar.js';
import '../components/header.js';
import '../components/accordion.js';
import '../components/desktop-slider.js';
import '../components/media.js';
import NewsletterForm from '../components/newsletter-form.js';
import { initScrollingText, initPinnedElements, initMovingElements } from '../components/gsap-animations.js';

import '../snippets/product-tile.js';
import '../snippets/wishlist.js';
import '../snippets/geolocation.js';
import '../snippets/collection-filters.js';
import '../snippets/share-buttons.js';
import '../snippets/contact-form.js';
import '../snippets/carousel-banner.js';
import '../snippets/lang-switcher.js';
import '../snippets/country-switcher.js';
import '../sections/newsletter-popup.js';
import { moneyConverter } from '../helpers';
import Cookies from 'js-cookie';

$(function () {
  Tabs();
  NewsletterForm();

  if (typeof window.Ajaxinate !== 'undefined' && (document.getElementById('AjaxinateContainer') || document.querySelector('.blog__articles--ajaxinate'))) {
    // clear from hashtag
    if(window.location.href.indexOf('#')!= -1){
      const url_data = window.location.href.replace('#','');
      history.pushState(null, "", url_data);
    }

    var anchorStart = window.location.href.indexOf('#');
    var itemID = anchorStart != -1 ? window.location.href.substr(anchorStart) : ''
    var preLoadingEnded = true; // Flag to check if were loading back pages
    var ajaxPageParamStart = window.location.href.indexOf('?i=');
    var ajaxPageParamEnd = anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
    var ajaxPageNumber = ajaxPageParamStart != -1 ? parseInt(window.location.href.substr(ajaxPageParamStart, ajaxPageParamEnd).replace('?i=', '')) : false;



    var preLoadNextPage = function () {
      window.endlessScroll.currentPage++
      window.endlessScroll.pagesToLoad--;

      window.setTimeout(function () {
        if (window.endlessScroll.nextPageLinkElement) {
          window.endlessScroll.nextPageUrl = window.endlessScroll.nextPageLinkElement.getAttribute('href');
          window.endlessScroll.loadMore();
        }
      }, 10); // Please lord of javascript forgive me for this!

      if (!window.endlessScroll.pagesToLoad) {
        preLoadingEnded = true;
      }
    }

    if (document.querySelector('.blog')) {
      const ajaxinateContainer = document.querySelector('.blog__articles--ajaxinate');
      const ajaxinatePagination = document.querySelector('.blog__pagination--ajaxinate');
      const elementsCounter = document.querySelector('.blog__footer [data-counter]');
      if (ajaxinateContainer && ajaxinatePagination && typeof (window.Ajaxinate) !== 'undefined') {
        window.endlessScroll = new Ajaxinate({
          container: '.blog__articles--ajaxinate',
          pagination: '.blog__pagination--ajaxinate',
          method: 'click',
          callback: function (requestURL) {
            window.dAgency.ajaxinateCallBack(requestURL, '.blog__articles--ajaxinate');
            if (elementsCounter) {
              elementsCounter.innerText = ajaxinateContainer.querySelectorAll('.blog__article').length;
            }
          }
        });
      }
    } else {
      window.endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'click',
        callback: function (requestURL) {
          window.dAgency.ajaxinateCallBack(requestURL);
        }
      });
      document.querySelector('#AjaxinatePagination').style.display = "block";
    }

    if (typeof (window.endlessScroll) !== 'undefined') {
      window.endlessScroll.currentPage = 1;
    }

    if (ajaxPageNumber) {
      window.scrollTo({ left: 0, top: 0 });
      preLoadingEnded = false;
      window.endlessScroll.pagesToLoad = ajaxPageNumber - 1;
      preLoadNextPage();
    }
  }

  $('[data-timed-popup]').TimedPopup();

  window.dAgency.ajaxinateCallBack = (requestURL, ajaxinateSelector = '#AjaxinateContainer') => {
    var $proxyLinks = $(ajaxinateSelector).find('[data-link-proxy]');

    if ($proxyLinks.length > 1) {
      $proxyLinks.off('click');

      $proxyLinks.ProxyLink({
        excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product'],
        onBeforeUnload: function ($proxyLink) {
          const itemID = $proxyLink.data('pid');
          const requestedPageNum = requestURL.substr(requestURL.indexOf('?page=')).replace('?page=', '');

          if (itemID) {
            history.replaceState({}, 'page ' + requestedPageNum, '?i=' + requestedPageNum + '#' + itemID);
          } else {
            history.replaceState({}, 'page ' + requestedPageNum, '?i=' + requestedPageNum);
          }
        }
      });
    }

    // Init wishlist buttons
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

    // Scroll back to latest position
    var requestedPageNum = requestURL.substr(requestURL.indexOf('?page=')).replace('?page=', '');

    if (preLoadingEnded) {
      window.endlessScroll.currentPage = requestedPageNum;

      if (itemID) {
        history.replaceState({}, 'page ' + requestedPageNum, '?i=' + requestedPageNum + itemID);
      } else {
        history.replaceState({}, 'page ' + requestedPageNum, '?i=' + requestedPageNum);
      }
    }

    if (!window.endlessScroll.pagesToLoad) {
      const headersHeight = $('.site-header').outerHeight(true);

      if (itemID) {
        var itemTop = $(itemID).offset().top - headersHeight;
        window.scrollTo({ left: 0, top: itemTop, behavior: 'smooth' });
        itemID = '';
      }
    }

    if (typeof window.dAgency.initProductTile !== 'undefined') {
      document.querySelectorAll('.product-tile__container').forEach(tile => {
        window.dAgency.initProductTile(tile);
      });
    }

    moneyConverter();
    if (window.endlessScroll.pagesToLoad) {
      preLoadNextPage();
    }
  }

  const $orderLists = $('[data-order-list]');
  if ($orderLists.length) {
    $orderLists.each(function () {
      const $list = $(this);
      $list.find('[data-order-number]').sort(function (a, b) {
        return +a.dataset.orderNumber - +b.dataset.orderNumber;
      })
        .appendTo($list);
    });
    window.setTimeout(function () {
      $orderLists.attr('data-order-list', 'ready');
    }, 50);
  }

  if (!window.dAgency) window.dAgency = {};

  window.dAgency.proxyLinkSetup = $context => {
    if (!$context || !$context.length) $context = $('body');
    const $proxyLinks = $context.find('[data-link-proxy]');

    if ($proxyLinks.length) {
      $proxyLinks.off('click'); // Removing previous proxy link initialization

      $proxyLinks.ProxyLink({
        excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product']
      });
    }
  }

  moneyConverter();
  if (Cookies.get('COMPLETED_LOADING') === 'true' || !document.querySelector('.site-loader__container')) {
    initScrollingText();
    initPinnedElements();
    initMovingElements();
  } else {
    document.addEventListener('loaderended', () => {
      setTimeout(() => {
        initScrollingText();
        initPinnedElements();
        initMovingElements();
      }, 1000);
    });
  }

  $(document).on('click', function(event) {
    const $target = $(event.target);
    const $searchPopup = $('.header__search-popup');
    const $headerContainer = $('.header__container');

    window.requestAnimationFrame(function(){
      const $header = $('#shopify-section-header .header__container');
      const $announcement = $('#shopify-section-announcement-bar');
      const viewportHeight = $(window).height();
      let headerBlocksHeight = 0;

      if($header.length) {
        headerBlocksHeight += $header.outerHeight(true);
      }

      if($announcement.length) {
        headerBlocksHeight += $announcement.outerHeight(true);
      }

      if($searchPopup.length) {
        headerBlocksHeight += $searchPopup.outerHeight(true);
      }

      const viewportAvailableSpace = viewportHeight - headerBlocksHeight;
      const viewportPercentageAvailableSpace = 100 * viewportAvailableSpace / viewportHeight;

      document.documentElement.style.setProperty('--viewportPercentageAvailableSpace', viewportPercentageAvailableSpace + 'vh');
    });

    if ($target.length && $target.closest('.rebuy-quick-view-dropdown__close').length) {
      $searchPopup.removeClass('open');
      $headerContainer.removeClass('force-opacity');
    }
  });
});
